import {
    EUROPACE_COMPLETENESS_CATEGORIES,
    EUROPACE_COMPLETENESS_IDENTIFIER_TYPES,
    EUROPACE_COMPLETENESS_REASONS,
} from 'cpool-constants';
import { z } from 'zod';

export const schemaCompletenessMessage = z.object({
    category: z.nativeEnum(EUROPACE_COMPLETENESS_CATEGORIES).optional(),
    identifier: z
        .object({
            ids: z.array(z.string()),
            type: z.nativeEnum(EUROPACE_COMPLETENESS_IDENTIFIER_TYPES),
        })
        .passthrough()
        .optional(),
    property: z.string().optional(),
    reason: z.nativeEnum(EUROPACE_COMPLETENESS_REASONS).optional(),
    text: z.string().optional(),
});

export type SchemaCompletenessMessage = z.infer<typeof schemaCompletenessMessage>;
